
<template>
  <div class="invoice thermal" id="reminder_node1" style="background:#fff">
    
    
    <button class="noprint" @click="print">Print</button>
  </div>
</template>

<script>
import {invoiceTemplateMixin} from '../invoice_template_mixin'
import footerComponent from '../components/invoice_footer_section'

// import { table } from 'table';
// Using commonjs?
// const { table } = require('table');


	export default{
		mixins: [invoiceTemplateMixin],
		components:{
			'footer-component':footerComponent
		},
        // data() {
        //     return {
        //     invoiceData: [
        //         {
        //         baseTransactionListId: "10003",
        //         baseTransactionNumber: "INV001",
        //         cols: {
        //             itemName: "Sample Item",
        //             qty: 10.0,
        //             rate: 100.0,
        //             netAmount: 1050.0,
        //             addOns: [
        //             { name: "CGST", percentage: 2.5, value: 25.0 },
        //             { name: "SGST", percentage: 2.5, value: 25.0 }
        //             ]
        //         }
        //         }
        //     ]
        //     };
        // },
        methods:{

            print(){
              console.log(output);
            },
            // printInvoice: function(){
            //     this.$root.fn_generateImage({});
            // },

            printInvoice: function() {
              // Sample Dynamic Invoice Data (Replace with API or Database Data)
              let invoiceData = {
                  businessName: "Test Business",
                  billTo: "Demo Customer",
                  poNo: "Ndnsk",
                  poDate: "04-Feb-2025",
                  mode: "Road",
                  lrNo: "Hd",
                  vehicleNo: "Hd",
                  invoiceNo: "INV008",
                  date: "26-Feb-2025",
                  items: [
                      {
                          name: "Sample Item",
                          qty: 10,
                          rate: 100.00,
                          amount: 1000.00,
                          brand: "Xyz",
                          company: "Abc",
                          category: "Test Category",
                          cgst: 23.75,
                          sgst: 23.75,
                          discount: 50.00
                      },
                      {
                          name: "Sample Item for Test",
                          qty: 15,
                          rate: 150.00,
                          amount: 2250.00,
                          desc: "Ndhxnnx",
                          cgst: 53.44,
                          sgst: 53.44,
                          cessQty: 150.00,
                          cess: 106.88,
                          discount: 112.50
                      }
                  ],
                  subtotal: 3087.50,
                  totalTax: 411.26,
                  discountTotal: 349.88,
                  totalAmount: 3148.88,
                  received: 0,
                  remaining: 3148.88,
                  grandTotal: 3148.88,
                  note: "Nxhxjds",
                  terms: [
                      "All disputes are subject to Delhi Jurisdiction.",
                      "Certified that the particulars given above are true and correct."
                  ]
              }

              // Start invoice output
              let invoiceText = "<pre>";
              invoiceText += `             ${invoiceData.businessName}\n`;
              invoiceText += "----------------------------------------\n";
              invoiceText += `Bill To: ${invoiceData.billTo}\n`;
              invoiceText += `PO No.: ${invoiceData.poNo}      PO Date: ${invoiceData.poDate}\n`;
              invoiceText += `Mode: ${invoiceData.mode}        LR/CR/RR No.: ${invoiceData.lrNo}\n`;
              invoiceText += `Vehicle No.: ${invoiceData.vehicleNo}\n`;
              invoiceText += "----------------------------------------\n\n";

              invoiceText += `Invoice No: ${invoiceData.invoiceNo}\n`;
              invoiceText += `Date: ${invoiceData.date}\n`;
              invoiceText += "----------------------------------------\n";
              invoiceText += "Item - QTY         Rate    Amount\n";
              invoiceText += "----------------------------------------\n";

              // Loop through items
              invoiceData.items.forEach(item => {
                  // invoiceText += `${item.name.padEnd(22)}${String(item.qty).padEnd(5)}${String(item.rate.toFixed(2)).padEnd(7)}${item.amount.toFixed(2)}\n`;
                  invoiceText += `${item.name} ${String(item.qty).padEnd(5)}${String(item.rate.toFixed(2)).padEnd(10)}${item.amount.toFixed(2)}\n`;
                  if (item.brand) invoiceText += `Brand: ${item.brand}\n`;
                  if (item.company) invoiceText += `Company: ${item.company}\n`;
                  if (item.category) invoiceText += `Category: ${item.category}\n`;
                  if (item.desc) invoiceText += `Desc: ${item.desc}\n`;
                  invoiceText += `CGST (2.5%): ${item.cgst.toFixed(2)}\n`;
                  invoiceText += `SGST (2.5%): ${item.sgst.toFixed(2)}\n`;
                  if (item.cessQty) invoiceText += `CESS on QTY (%): ${item.cessQty.toFixed(2)}\n`;
                  if (item.cess) invoiceText += `CESS (5%): ${item.cess.toFixed(2)}\n`;
                  invoiceText += `Discount (5%): -${item.discount.toFixed(2)}\n`;
                  invoiceText += "----------------------------------------\n";
              });

              invoiceText += `Subtotal:              ₹${invoiceData.subtotal.toFixed(2)}\n`;
              invoiceText += `Total Tax:             ₹${invoiceData.totalTax.toFixed(2)}\n`;
              invoiceText += `Discount:             -₹${invoiceData.discountTotal.toFixed(2)}\n`;
              // invoiceText += "----------------------------------------\n";
              invoiceText += `Total Amount:          ₹${invoiceData.totalAmount.toFixed(2)}\n`;
              invoiceText += `Received:              ₹${invoiceData.received.toFixed(2)}\n`;
              invoiceText += `Remaining Amount:      ₹${invoiceData.remaining.toFixed(2)}\n`;
              invoiceText += "----------------------------------------\n\n";

              invoiceText += `         Grand Total: ₹${invoiceData.grandTotal.toFixed(2)}\n`;
              invoiceText += "----------------------------------------\n\n";

              invoiceText += `Note: ${invoiceData.note}\n`;
              invoiceText += "Thank you for your purchase!\n\n";

              invoiceText += "Terms & Conditions:\n";
              invoiceData.terms.forEach(term => {
                  invoiceText += `- ${term}\n`;
              });

              invoiceText += "</pre>";

              // Write to the document and print
              // document.write(invoiceText);
              document.getElementById('reminder_node1').innerHTML = invoiceText;

            },

            wrapText(text, width) {
              let wrappedText = "";
              while (text.length > width) {
                  wrappedText += text.substring(0, width) + "\n";
                  text = text.substring(width);
              }
              wrappedText += text; 
              return wrappedText;
          },

          //   printInvoice: function() {
          //     let invoiceData = {
          //         businessName: "Test Business",
          //         billTo: "Demo Customer",
          //         invoiceNo: "INV008",
          //         date: "26-Feb-2025",
          //         items: [
          //             { name: "Sample Item", qty: 10, rate: 100.00, amount: 1000.00 },
          //             { name: "Very Long Item Name for Testing", qty: 5, rate: 200.00, amount: 1000.00 }
          //         ],
          //         subtotal: 2000.00,
          //         totalTax: 100.00,
          //         discountTotal: 50.00,
          //         totalAmount: 2050.00,
          //         received: 0,
          //         remaining: 2050.00,
          //         grandTotal: 2050.00
          //     };

          //     let invoiceText = `<pre>`;
          //     invoiceText += `        ${invoiceData.businessName}\n`;
          //     invoiceText += `--------------------------------\n`;
          //     invoiceText += `Bill To: ${invoiceData.billTo}\n`;
          //     invoiceText += `Invoice: ${invoiceData.invoiceNo}   ${invoiceData.date}\n`;
          //     invoiceText += `--------------------------------\n`;
          //     invoiceText += `Item             QTY  Rate  Total\n`;
          //     invoiceText += `--------------------------------\n`;

          //     let self = this;
          //     invoiceData.items.forEach(item => {
          //         let wrappedName = self.wrapText(item.name, 16);
          //         let lines = wrappedName.split("\n");

          //         invoiceText += `${lines[0].padEnd(16)} ${String(item.qty).padStart(2)} ${String(item.rate.toFixed(2)).padStart(6)} ${String(item.amount.toFixed(2)).padStart(7)}\n`;
          //         for (let i = 1; i < lines.length; i++) {
          //             invoiceText += `${lines[i]}\n`;
          //         }
          //     });

          //     invoiceText += `--------------------------------\n`;
          //     invoiceText += `Subtotal:         ₹${invoiceData.subtotal.toFixed(2)}\n`;
          //     invoiceText += `Tax:              ₹${invoiceData.totalTax.toFixed(2)}\n`;
          //     invoiceText += `Discount:        -₹${invoiceData.discountTotal.toFixed(2)}\n`;
          //     invoiceText += `--------------------------------\n`;
          //     invoiceText += `Total:            ₹${invoiceData.totalAmount.toFixed(2)}\n`;
          //     invoiceText += `Received:         ₹${invoiceData.received.toFixed(2)}\n`;
          //     invoiceText += `Due:              ₹${invoiceData.remaining.toFixed(2)}\n`;
          //     invoiceText += `--------------------------------\n`;
          //     invoiceText += ` Grand Total: ₹${invoiceData.grandTotal.toFixed(2)}\n`;
          //     invoiceText += `--------------------------------\n`;
          //     invoiceText += ` Thank you for your business!\n`;
          //     invoiceText += `</pre>`;

          //     document.getElementById('reminder_node1').innerHTML = invoiceText;

          //     // let printWindow = window.open('', '', 'width=288');
          //     // printWindow.document.write(invoiceText);
          //     // printWindow.document.close();
          //     // printWindow.print();
          // }
        },  
    //     computed: {
    //     invoice() {
    //     return this.invoiceData[0];
    //     }
    // },
	}
</script>

<style>
.invoice{
    width: 288px;
    /* margin: auto; */
    padding-top: 8px;
    /* margin-right: 5px; */
}
.invoice p{
  margin: 0 !important;
}
.center {
  text-align: center;
}
.bold {
  font-weight: bold;
}
.receipt {
  border-top: 1px dashed black;
  border-bottom: 1px dashed black;
  padding: 5px 0;
  margin: 5px 0;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  padding: 5px;
}
.summary_table th, .summary_table td{
  padding: 0 5px !important;
}
.header_table th, .header_table td{
  padding: 0px 5px;
}
.total {
  border-top: 1px solid black;
  font-weight: bold;
}
.noprint {
  display: block;
  margin: 10px auto;
}

.thermal .logo_container .editable{
  width: fit-content;
  margin: auto;
  padding: 2px;
}

.left-align{
  text-align: left;
}
.right-align{
  text-align: right;
}
.center-align{
  text-align: center;
}
@media print {
  .noprint {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/invoice_templates/invoices/template7.vue